import { lazy } from 'react';

// Service Intelligence
// Block F.3.b — IntelligenceDashboard / PatternAnalysis / AutomationCandidates
// pages deleted. They were orphaned (no route registration anywhere) and
// superseded by the Service Intelligence surfaces + the canonical /api/v1/dashboard/service-intelligence
// provider reached via the Portfolio Analytics destination.
// ObserveImprove retired 2026-05-28 — absorbed as the Observe view of the
// Compliance · Service Intelligence tab (compliance-assessment/pages/ServiceIntelligenceObserveView.tsx).

// Configuration Drift: BaselineManagement and MonitoringPolicies are the
// routed admin consoles. The unrouted DriftDashboard page (pages/Drift.tsx)
// was deleted (hyp-fn6xm); drift monitoring lives in compliance-assessment's
// DriftMonitorPage, which opens the CompareDrawer.

export const BaselineManagement = lazy(() =>
  import('@/capabilities/configuration-drift/pages/BaselineManagement').then((m) => ({
    default: m.BaselineManagement,
  }))
);

export const MonitoringPolicies = lazy(() =>
  import('@/capabilities/configuration-drift/pages/MonitoringPolicies').then((m) => ({
    default: m.MonitoringPolicies,
  }))
);
